import { DateRangeEnum } from '@shared/common/types/main';
import {
  CallbackExportRequest,
  CallbackLogFilter,
  CallbackReportingFilter,
  CallbackReportingGroupBy,
  CallbackStatus,
} from '@shared/models/callback';

export const CUSTOMER_VISIBLE_CALLBACK_STATUSES: CallbackStatus[] = [
  CallbackStatus.Sent,
];

export const CUSTOMER_CALLBACK_DEFAULT_RANGE_DAYS = 30;

interface CustomerCallbackFilterArgs {
  organisationId: string;
  startDate: string;
  endDate: string;
  knowledgebaseIds?: string[];
  statuses?: CallbackStatus[];
}

interface CustomerCallbackLogFilterArgs extends CustomerCallbackFilterArgs {
  pageNumber?: number;
  pageSize?: number;
}

const buildCustomerCallbackBaseFilter = ({
  organisationId,
  startDate,
  endDate,
  knowledgebaseIds,
  statuses,
}: CustomerCallbackFilterArgs) => ({
  organisation_ids: [organisationId],
  date_from: startDate,
  date_to: endDate,
  ...(knowledgebaseIds?.length ? { knowledgebase_ids: knowledgebaseIds } : {}),
  statuses: statuses?.length ? [...statuses] : [...CUSTOMER_VISIBLE_CALLBACK_STATUSES],
});

export const buildCustomerCallbackLogFilter = ({
  organisationId,
  startDate,
  endDate,
  knowledgebaseIds,
  statuses,
  pageNumber,
  pageSize,
}: CustomerCallbackLogFilterArgs): CallbackLogFilter => ({
  ...buildCustomerCallbackBaseFilter({
    organisationId,
    startDate,
    endDate,
    knowledgebaseIds,
    statuses,
  }),
  ...(pageNumber ? { page_number: pageNumber } : {}),
  ...(pageSize ? { page_size: pageSize } : {}),
});

export const buildCustomerCallbackExportRequest = ({
  organisationId,
  startDate,
  endDate,
  knowledgebaseIds,
  statuses,
}: CustomerCallbackFilterArgs): CallbackExportRequest => ({
  ...buildCustomerCallbackBaseFilter({
    organisationId,
    startDate,
    endDate,
    knowledgebaseIds,
    statuses,
  }),
});

export const buildCustomerCallbackReportingFilter = ({
  organisationId,
  startDate,
  endDate,
  knowledgebaseIds,
  statuses,
}: CustomerCallbackFilterArgs): CallbackReportingFilter => ({
  organisation_ids: [organisationId],
  insight_ids: knowledgebaseIds?.length ? [...knowledgebaseIds] : [],
  knowledgebase_ids: knowledgebaseIds?.length ? [...knowledgebaseIds] : [],
  date_range: DateRangeEnum.Custom,
  date_from: startDate,
  date_to: endDate,
  statuses: statuses?.length ? [...statuses] : [...CUSTOMER_VISIBLE_CALLBACK_STATUSES],
  group_by: CallbackReportingGroupBy.Status,
});
